export default function ShinyText({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={className}
      style={{
        backgroundImage: 'linear-gradient(90deg, #D4AF37 0%, #FFD700 30%, #FFA000 50%, #FFD700 70%, #D4AF37 100%)',
        backgroundSize: '200% auto',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        animation: 'shimmer 3s linear infinite',
      }}
    >
      {children}
    </span>
  );
}
